// extracted by mini-css-extract-plugin
module.exports = {"CommentListPlaceholder":"iw_a bhp_je","CommentListPlaceholder--Legacy":"iw_b bhp_qh bhp_vk"};